module.exports = __webpack_public_path__ + "img/cs_logo_light.c6845681.png";